<template>
  <!-- TIME REPORT -->
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
    <!-- DIALOG MESSAGE AFTER THE REQUEST OF A REPORT -->
    <v-dialog
      v-model="showReportMessage"
      max-width="390"
      persistent>
      <v-card
        class="py-2"
      >
        <h2 class="text-xs-center mt-3">
          Solicitud en Proceso
        </h2>
        <v-flex v-if="reportMessageType === 'success'" pa-4>
          <p>Estamos generando su reporte. Una vez esté listo para ser descargado, se le notificará.</p>
          <ul>
            <li>
              <b>NOTA1:</b> Dependiendo de las características de cada reporte, este proceso puede tardar hasta 10min.
            </li>
            <li>
              <b>NOTA2:</b> Por favor no cierre el panel de control hasta que el proceso no haya finalizado.
            </li>
          </ul>
        </v-flex>
        <v-flex v-else pa-4>
          <p>Se ha presentado un error al tratar de generar el reporte. Por favor intentelo de nuevo.</p>
          <br />
          <p>Sí el error persiste por favor contactar al administrador del sistema.</p>
        </v-flex>
        <v-card-actions class="text-xs-right pr-4 mb-2">
           <v-spacer></v-spacer>
          <v-btn color="primary" @click="showReportMessage = false">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>      
    </v-dialog>
    <h3 class="text-xs-left pt-2">Recorrido de un vehículo</h3>
    <h4 class="text-xs-left pt-2">Reporte por Tiempo</h4>

    <v-flex mt-3 px-1 pb-2>
      <v-text-field
        ref="search"
        v-model="searchVehicleValue"
        flat
        box
        prepend-inner-icon="search"
        color="white"
        label="Código/Sigla ó Placa"
        @keyup.enter="searchVehicle"
        @change="searchVehicle">
      </v-text-field>
      <v-flex v-if="showOk">
        <v-icon color="green">check_circle</v-icon> Vehículo Disponible
      </v-flex>
      <v-flex v-else-if="showStop">
        <v-icon color="red">not_interested</v-icon> Vehículo No Disponible
      </v-flex>
    </v-flex>

    <!-- DATE & TIME -->
      <v-flex px-1 mt-3 v-if="showOk">
        <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
        <v-flex>
          <v-menu              
            lazy
            ref="menu0"
            v-model="menu0"
            transition="scale-transition"
            :close-on-content-click="false"
            :return-value.sync="dates0"
            offset-y      
            origin="top"
            color="white">
            <template v-slot:activator="{ on }">
              <v-combobox                  
                v-model="dates0"
                multiple
                chips
                small-chips
                label="Fecha"
                placeholder="Escoger el día a consultar"
                prepend-inner-icon="event"
                readonly
                box
                color="white"
                v-on="on">
              </v-combobox>
            </template>                      
            <v-date-picker 
              v-model="dates0"
              multiple
              no-title
              scrollable
              :first-day-of-week="1"
              locale="es-sp"                        
              :allowed-dates="allowedDates0"
              color="blue accent-3"                  
              @input="changesDate0">
              <v-spacer></v-spacer>
              <v-btn color="error" @click="menu0 = false">Cancelar</v-btn>
              <v-btn color="primary" @click="acceptDate0">Aceptar</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <!-- MENU TIME 1 DATE 1 -->
        <v-flex v-if="showInitialTime0">
            <!-- :disabled="eventsLoaded" -->
            <!-- class="mx-1" -->
            <!-- nudge-top="300" -->
            <!-- nudge-left="-10" -->
          <v-menu
            ref="time1Date1Menu0"
            lazy
            :close-on-content-click="false"
            v-model="time1Date1Menu0"
            transition="scale-transition"
            offset-x
            left
            full-width
            allow-overflow
            min-width="290px"
            origin="top right"
            :return-value.sync="time1Date10">
              <!-- :disabled="eventsLoaded" -->
            <v-text-field
              slot="activator"
              label="Hora Inicial"
              placeholder="Seleccionar Hora"
              v-model="time1Date10"
              prepend-inner-icon="av_timer"
              readonly
              box
              hide-details
              color="white"/>
            <v-time-picker 
              v-model="time1Date10"
              format="24hr"
              scrollable
              color="teal darken-1"
              header-color="grey darken-4"
              @input="changeTime10">
              <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
              <v-spacer></v-spacer>
              <v-btn color="error" @click="time1Date1Menu0 = false">Cancelar</v-btn>
              <v-btn color="primary" @click="acceptTime10">Aceptar</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
        <!-- TIME 2 DATE 1 MENU -->
        <v-flex v-if="showFinalTime0" mt-3>
            <!-- :disabled="eventsLoaded" -->
            <!-- class="mx-1" -->
            <!-- nudge-top="-15" -->
          <v-menu
            ref="time2Date1Menu0"
            lazy
            :close-on-content-click="false"
            v-model="time2Date1Menu0"
            transition="scale-transition"
            offset-x
            left
            full-width
            min-width="290px"
            origin="top right"
            :return-value.sync="time2Date10">
              <!-- :disabled="eventsLoaded" -->
            <v-text-field
              slot="activator"
              label="Hora Final"
              placeholder="Seleccionar Hora"
              v-model="time2Date10"
              prepend-inner-icon="av_timer"
              readonly
              box
              hide-details
              color="white"/>
            <v-time-picker 
              v-model="time2Date10"
              format="24hr"
              scrollable
              :allowed-hours="allowedHours0"
              :allowed-minutes="allowedMinutes0"
              color="red darken-1"
              header-color="grey darken-4"
              @click:hour="hourClicked0"
              @change="changeTime20">
              <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
              <v-spacer></v-spacer>
              <v-btn color="error" @click="time2Date1Menu0 = false">Cancelar</v-btn>
              <v-btn color="primary" @click="$refs.time2Date1Menu0.save(time2Date10)">Aceptar</v-btn>
            </v-time-picker>

          </v-menu>
        </v-flex>
      </v-flex>
      <!-- BUTTON -->
      <v-flex class="text-xs-center" my-3 pb-3 v-if="showOk">
          <!-- :href="urlReportPoint" -->
        <v-btn
          :disabled="reportTimeDisabled"
          target="_blank"
          color="primary"
          block
          :loading="$loading.isLoading('generatingTimeReport')"
          @click="downloadTimeReport"
        >
          <v-icon left>cloud_download</v-icon>
          Generar Reporte
        </v-btn>
      </v-flex>
  </v-flex>  
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'report-by-route-time',
    data() {
      return {
        reportMessageType: '',
        showReportMessage: false,
        time2Date1Menu0: false,
        limitHour0: null,
        limitMinute0: null,
        limitTime0: null,
        onlyDate10: null,
        onlyDate20: null,
        date10: null,
        date20: null,
        dates0: [],
        showFinalTime0: false,
        time2Date10: null,
        showInitialTime0: false,
        time1Date1Menu0: false,
        time1Date10: null,
        menu0: false,
        showOk: false,
        showStop: false,
        searchVehicleResult: [],
        searchAction: false,
        searchVehicleValue: null
      }
    },
    computed: {
      reportTimeDisabled() {
        let result = true
        if (this.dates0.length === 1 && this.time1Date10 && this.time2Date10) result = false
        return result
      }
    },
    methods: {
      ...mapActions([
        'getTimeReport',
        'searchVehicleAction'
      ]),
      initData() {
        this.time2Date1Menu0 = false
        this.limitHour0 = null
        this.limitMinute0 = null
        this.limitTime0 = null
        this.onlyDate10 = null
        this.onlyDate20 = null
        this.date10 = null
        this.date20 = null
        this.dates0 = []
        this.showFinalTime0 = false
        this.time2Date10 = null
        this.showInitialTime0 = false
        this.time1Date1Menu0 = false
        this.time1Date10 = null
        this.menu0 = false
        this.showOk = false
        this.showStop = false
        this.searchVehicleResult = []
        this.searchAction = false
        this.searchVehicleValue = null
      },
      allowedDates0(date) {
        let today = this.$moment.now()
        let datesResult = this.$moment(date).isBefore(today)
        today = this.$moment(today).format('YYYY-MM-DD')

        if (this.dates0.length === 1) datesResult = date === this.dates0[0]

        return datesResult
      },
      async downloadTimeReport() {
        const payload = {
          id: this.searchVehicleResult[0].id,
          date1: this.date10,
          time1Date1: this.time1Date10,
          date2: this.date20,
          time1Date2: this.time2Date10
        }
        // console.log('DOWNLOAD TIME REPORT: ', payload)
        const result = await this.getTimeReport(payload)
        // console.log('downloadTimeReport: ', result)
        this.showReportMessage = true
        if (result === 'OK') {
          this.reportMessageType = 'success'
          this.initData()
        } else {
          this.reportMessageType = 'error'
          // alert('Se ha presentado un error al tratar de generar el reporte. Por favor intente de nuevo.')
        }
      },
      changesDate0() {
        // console.log('CHANGE DATE')
        if (this.dates0.length === 0) {
          this.showInitialTime0 = false
          this.showFinalTime0 = false
          this.onlyDate10 = null
          this.onlyDate20 = null
          this.date10 = null
          this.date20 = null
          this.limitTime0 = null
          this.limitHour0 = null
          this.limitMinute0 = null
          this.time1Date1Menu0 = false
          this.time1Date10 = null
          this.time2Date1Menu0 = false
          this.time2Date10 = null
        } else {
          this.date10 = this.dates0[0]
          this.date20 = this.dates0[0]
        }
      },
      changeTime10() {
        // console.log('CHANGE TIME 10')
        this.time2Date10 = null
      },
      hourClicked0(value) {
        // console.log('HOUR CLICKED', value)
      },
      changeTime20() {
        // console.log('CHANGE TIME 2', this.time1Date10, this.time2Date10)
        // const startTime = this.$moment(this.time1Date10, 'HH:mm')
        // const finalTime = this.$moment(this.time2Date10, 'HH:mm')
        // console.log('startTime: ', startTime)
        // console.log('finalTime: ', finalTime)
        // const differenceTime = this.$moment.startTime.diff(finalTime, 'hours')
        // console.log('DIFF: ', differenceTime)
      },
      allowedMinutes0(value) {
        // console.log('allowedMinutes', value, this.time2Date1)
        if (this.time2Date10 !== null) {
          const selectedHour = this.time2Date10.split(':')
          // console.log('selectedHour: ', Number(selectedHour[0]), Number(this.limitHour))
          if (Number(selectedHour[0]) === Number(this.limitHour0)) {
            // console.log('********* ', value, this.limitMinute)
            if (value <= this.limitMinute0) return true
            else return false
          }
        }
        return true
      },
      allowedHours0(value) {
        // console.log('allowedHours', value, this.time1Date1)
        const myDate = `${this.dates0[0]} ${this.time1Date10}`
        // this.date10 = this.$moment(myDate).format('YYYY-MM-DD HH:mm:ss')
        this.date10 = this.dates0[0]

        if (this.time2Date10) {
          const selectedHour1 = this.time1Date10.split(':')
          const selectedHour2 = this.time2Date10.split(':')
          let myDate2 = null
          // console.log('selectedHour2 time2Date1', Number(selectedHour2[0]), this.onlyDate1, this.onlyDate2)
          // console.log(this.onlyDate1 !== this.onlyDate2)
          // console.log(Number(selectedHour2[0]) < Number(selectedHour1[0]))

          if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate10 !== this.onlyDate20) myDate2 = this.onlyDate20
          else myDate2 = this.dates0[0]

          // console.log('MY DATE 2: ', myDate2)

          this.date20 = this.$moment(myDate2).format('YYYY-MM-DD')
          // console.log('DATE 20: ', this.date20)
        }
        // console.log('MY DATE: ', myDate)
        // const selectedHour = this.$moment(myDate).format('H')
        // console.log('selectedHour', selectedHour)
        const allowedHoursArray = []
        for (let i = 0; i <= 6; i++) {
          const h = this.$moment(myDate).add(i, 'hours').format('H')
          allowedHoursArray.push(Number(h))
        }
        // console.log('allowedHoursArray: ', allowedHoursArray)

        // const oneAfter = this.$moment(myDate).add(1, 'hours').format('H')
        this.limitTime0 = this.$moment(myDate).add(6, 'hours').format('YYYY-MM-DD HH:mm:ss')
        this.onlyDate10 = this.$moment(myDate).format('YYYY-MM-DD')
        this.onlyDate20 = this.$moment(myDate).add(6, 'hours').format('YYYY-MM-DD')
        // console.log('ONLY DATE 2: ', this.onlyDate2)
        this.limitHour0 = this.$moment(this.limitTime0).format('H')
        this.limitMinute0 = this.$moment(this.limitTime0).format('mm')
        // console.log('oneAfter: ', oneAfter)
        // console.log('limitTime: ', this.limitTime)
        // console.log('limitHour: ', this.limitHour)
        // console.log('limitMinute: ', this.limitMinute)
        const isIn = allowedHoursArray.filter(item => item === value)
        // console.log('IS IN: ', isIn)
        if (isIn.length > 0) {
          // console.log('VALUE: ', value)
          return true
        } else return false
      },
      acceptTime10() {
        this.$refs.time1Date1Menu0.save(this.time1Date10)
        this.time2Date10 = this.time1Date10
        this.showFinalTime0 = true
      },
      acceptDate0() {
        this.$refs.menu0.save(this.dates0)
        this.time1Date10 = '00:00'
        if (this.dates0.length > 0) this.showInitialTime0 = true
        else this.showInitialTime0 = false
      },
      searchVehicle() {
        // console.log('SEARCH', this.searchVehicleValue)
        if (this.searchVehicleValue !== null) {
          this.searchAction = false
          this.searchVehicleAction(this.searchVehicleValue)
            .then(result => {
              // this.searchVehicleValue = null
              this.searchAction = true
              // this.$refs.search.reset()
              this.searchVehicleResult = result
              // console.log('searchVehicleResult ', this.searchVehicleResult)
              if (this.searchVehicleResult.length > 0) {
                this.showOk = true
                this.showStop = false
              } else {
                this.showOk = false
                this.showStop = true
              }
              // console.log('RESULT', this.searchVehicleResult)
            })
        }
      }
    }
  }
 </script>
 
<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

.section-1
  min-width 390px
  max-width 390px
  
.general-bg
  background-color #424242
  border-radius 3px

 </style>



// WEBPACK FOOTER //
// src/components/Reports/ReportByRouteTime.vue